// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2rDRU","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3UqRz"};